




import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { toDataURL, toCanvas } from 'qrcode';

/***
 * 渲染二维码
 * @param {string} content 二维码内容
 * @param {number} [margin=0] 二维码图片的空白边距
 * @author jonahwang
 *
 * <QRCode content="www.example.com"/>
 */
@Component({})
export default class QRCode extends Vue {
  @Prop({
    type: String,
  })
  content!: string;

  @Prop({
    type: Number,
  })
  size!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  margin!: number;

  @Prop({
    type: Number,
    default: 0,
  })
  padding!: number;

  @Prop({
    type: String,
  })
  dark!: string;

  @Prop({
    type: String,
    default: 'L',
  })
  errorCorrectionLevel!: any;

  @Prop({
    type: String,
  })
  light!: string;

  image: string | null = null;

  @Watch('content', { immediate: true })
  updateQrContent(content: string) {
    return new Promise(async (resolve) => {
      const image = new Image();
      const canvas = document.createElement('canvas');
      image.src = await toDataURL(content, {
        margin: this.padding,
        width: this.size,
        color: {
          dark: this.dark,
          light: this.light,
        },
        errorCorrectionLevel: this.errorCorrectionLevel,
      });
      image.onload = () => {
        const context = canvas.getContext('2d');
        canvas.width = image.width + this.margin * 2;
        canvas.height = image.height + this.margin * 2;
        if (context) {
          context.drawImage(image, this.margin, this.margin);
          this.image = canvas.toDataURL();
        }
        resolve();
      };
    })
  }
}
